module.exports = __webpack_public_path__ + "static/media/JoinGroupImg.56661e69.svg";